import { gql } from '@apollo/client'

export default gql`
  mutation course_lessons_delete($id: ID!) {
    courseLessonDelete(id: $id) {
      id
    }
  }
`
